module.exports = __webpack_public_path__ + "img/icon-group10.ae03b683.png";